angular.module('iw.frontyard.translate')
    .service('Translator', function ($window) {

        class Translator {

            static translate(text) {
                if ($window.gettext) {
                    return $window.gettext(text);
                } else {
                    return text;
                }
            }

            static translateAs(text, context) {
                if ($window.gettext) {
                    return $window.pgettext(context, text);
                } else {
                    return text;
                }
            }

            static interpolate(text, obj, named) {
                if ($window.interpolate) {
                    return $window.interpolate(text, obj, named);
                } else {
                    return text;
                }
            }

            static translateAndInterpolate(text, obj, named) {
                var translatedText = Translator.translate(text);

                return Translator.interpolate(translatedText, obj, named);
            }

            static pluralize(singular, plural, count) {
                if ($window.ngettext) {
                    return $window.ngettext(singular, plural, count);
                } else {
                    return singular;
                }
            }
        }

        return Translator;
    });
